export const ENTITY = 0 as const;
export const USER = 1 as const;

export interface EditTagsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  selectedEntityIds?: number[];
  selectedUserIds?: number[];
}
